/** Matches mpz-api validationTools.passwordPolicyRegex: 10+ chars, upper, lower, number. */
const PASSWORD_POLICY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{10,})/

/**
 * Whether a password meets the same policy the API enforces in production.
 * @param {string} password
 * @returns {boolean}
 */
export function isPasswordStrongEnough(password) {
    return typeof password === 'string' && PASSWORD_POLICY_REGEX.test(password)
}
